import React from 'react';
import { connect } from 'react-redux';

import Customise from '../components/Browser/Customise';
import Loading from '../components/Browser/Loading';
import ProductFilters from '../components/Browser/ProductFilters';
import Products from '../components/Browser/Products';
import Start from '../components/Browser/Start';

import {
    customiseProduct,
    removeProduct,
    selectNamedProduct,
    selectProduct,
    selectSectionAndCategory,
    updateProjectTitle,
} from '../actions';
import sections from '../sections';

/**
 * Browser container
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 * @todo Sort out nomenclature re: selected (selectedProduct vs selected)
 */
const Browser = ({
    currentBuildIndex,
    section,
    selectedProduct,
    products,
    breadcrumbs,
    selected,
    loading,
    finished,
    projectTitle,
    dispatch,
    skintone,
    errorOnBuy,
}) => {
    // end screen
    const [showDescription, setShowDescription] = React.useState(false);
    
    React.useEffect(() => {
        setShowDescription(false);
    }, [selectedProduct]);

    if (finished && !errorOnBuy) {
        return null;
    }

    // within a section
    if (section) {
        let sectionTitle = section ? sections[section] : sections.hatsAndHair;

        // customising a product
        if (selectedProduct) {
            const selectedProductDetails =
                selected[section] !== null && selected[section].product.id == selectedProduct.id
                    ? selected[section]
                    : null;

            return (
                <div className="browser">
                    <Customise
                        projectTitle={projectTitle}
                        product={selectedProduct}
                        selected={selectedProductDetails}
                        showDescription={showDescription}
                        setShowDescription={setShowDescription}
                        onSelect={(product, attributes, addons, product_attribute, productFormJsonValues) =>
                            dispatch(
                                selectProduct(
                                    currentBuildIndex,
                                    product,
                                    attributes,
                                    addons,
                                    product_attribute,
                                    productFormJsonValues
                                )
                            )
                        }
                        onRemove={() => dispatch(removeProduct(currentBuildIndex, section))}
                        backButtonFunc={() => dispatch(selectSectionAndCategory(breadcrumbs?.category, null, skintone))}
                    />
                    <Loading loading={loading} />
                </div>
            );
        } else if (products?.length > 0) {
            // viewing a list of products within a category

            // console.log('Browser:', { products });

            return (
                <div className="browser">
                    <Products
                        products={products}
                        section={section}
                        selectedProducts={selected}
                        selected={selected[section]}
                        onSelect={(product, attributes, addons, product_attribute, productFormJsonValues) =>
                            dispatch(
                                selectProduct(
                                    currentBuildIndex,
                                    product,
                                    attributes,
                                    addons,
                                    product_attribute,
                                    productFormJsonValues
                                )
                            )
                        }
                        onSelectNamedProduct={(
                            currentBuildIndex,
                            product,
                            attributes,
                            addons,
                            product_attribute,
                            productSection,
                            productFormJsonValues
                        ) =>
                            dispatch(
                                selectNamedProduct(
                                    currentBuildIndex,
                                    product,
                                    attributes,
                                    addons,
                                    product_attribute,
                                    productSection,
                                    productFormJsonValues
                                )
                            )
                        }
                        currentBuildIndex={currentBuildIndex}
                        projectTitle={projectTitle}
                        onRemove={(section) => dispatch(removeProduct(currentBuildIndex, section))}
                        onCustomise={(product) => dispatch(customiseProduct(product))}
                        skintone={skintone}
                    />
                    <Loading loading={loading} />
                </div>
            );
        }

        // viewing categories within a section
        return (
            <div className="browser">
                <div className="products-container">
                    <ProductFilters />
                    <p className="infoText">
                        {loading ? 'Building figures...' : 'Sorry, there are no products matching these filters.'}
                    </p>
                </div>
                <Loading loading={loading} />
            </div>
        );
    }

    // show the start screen
    return (
        <div className="browser">
            <Start
                projectTitle={projectTitle}
                onStart={() =>
                    dispatch(
                        selectSectionAndCategory({
                            id: 'hatsAndHair',
                            title: 'Hats & Hair',
                            emptyText: 'Choose a hat or some hair',
                            handle: 'hair-and-hats',
                        })
                    )
                }
                onProjectTitleChange={(title) => dispatch(updateProjectTitle(title))}
            />
            <Loading loading={loading} />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        ...state.browser,
        currentBuildIndex: state.currentBuildIndex,
        section: state.navigation.selected,
        breadcrumbs: state.breadcrumbs,
        selected: state.builds[state.currentBuildIndex].selected,
        loading: state.loading,
        finished: state.finished,
        errorOnBuy: state.errorOnBuy,
        projectTitle: state.builds[state.currentBuildIndex].projectTitle,
        skintone: state.builds[state.currentBuildIndex].skintone,
    };
};

export default connect(mapStateToProps)(Browser);
